import { ApprovalConsiderationAnnounceNineComponent } from "../../../components/SupportSystem/ReportOnApprovalConsiderationResults/ApprovalConsiderationAnnounceNineComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";

export function ApprovalConsiderationAnnounceNineContainer() {
    const titleName = "รายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-5)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            {/* <NavbarSupportSystem /> */}
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <ApprovalConsiderationAnnounceNineComponent />
            <Footer />
        </div>
    )
}